module.exports = __webpack_public_path__ + "img/txt.0a1bce5d.png";